<script setup>
import { useColorMode } from "@vueuse/core";
import { darkTheme, NConfigProvider, NNotificationProvider } from "naive-ui";
import { TooltipProvider } from "reka-ui";
import { computed } from "vue";
import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";
import AppLayout from "@/components/layouts/AppLayout.vue";
import "boxicons";

const { store, system } = useColorMode();
const colorTheme = computed(() =>
	store.value === "auto" ? system.value : store.value,
);
</script>

<template>
	<NConfigProvider :theme="colorTheme === 'dark' ? darkTheme : null">
		<NNotificationProvider>
			<TooltipProvider>
				<AppLayout>
					<router-view v-slot="{ Component }">
						<Suspense>
							<div class="w-full h-full">
								<component :is="Component" />
							</div>
						</Suspense>
					</router-view>
				</AppLayout>
			</TooltipProvider>
		</NNotificationProvider>
	</NConfigProvider>
	<Toaster position="top-right" />
</template>
<style lang="postcss">
@import url("boxicons/css/boxicons.css");
</style>
